import { render, staticRenderFns } from "./pedido-detalhes.vue?vue&type=template&id=0d626898&"
import script from "./pedido-detalhes.vue?vue&type=script&lang=js&"
export * from "./pedido-detalhes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports